
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { DataInterpreterPipe } from '@spotter/pipes/data-intepreter-pipe';
import { EventService } from '@spotter/services/internal/event-service';
import { Filter, FilterService } from '@spotter/services/sightings/filter-service';
import { FilterPanelComponent } from '../filter-panel/filter-panel.component';



/** Handles the date range logic for the datepicker */
class DateRangeLogic {

    hoveredDate: NgbDate | null = null;
    fromDate: NgbDate | null;
    toDate: NgbDate | null;



    constructor(public formatter: NgbDateParserFormatter, private calendar: NgbCalendar, from: NgbDate | null, to: NgbDate | null) {
        this.fromDate = from;
        this.toDate = to;

    }

    onDateSelection(date: NgbDate) {
        if (!this.fromDate && !this.toDate)
        {
            this.fromDate = date;
        }
        else if (this.fromDate && !this.toDate && date && date.after(this.fromDate))
        {
            this.toDate = date;
        }
        else
        {
            this.toDate = null;
            this.fromDate = date;
        }
    }

    isHovered(date: NgbDate) {
        return (
            this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
        );
    }

    isInside(date: NgbDate) {
        return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }

    isRange(date: NgbDate) {
        return (
            date.equals(this.fromDate) ||
            (this.toDate && date.equals(this.toDate)) ||
            this.isInside(date) ||
            this.isHovered(date)
        );
    }

    validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
        const parsed = this.formatter.parse(input);
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
}

/** The main filter component which slides into the screen */
@Component({
    selector: 'filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    imports: [NgbModule, TranslatePipe, DataInterpreterPipe, FontAwesomeModule, FilterPanelComponent]
})
export class FilterComponent {

    thisYear: number;

    uploadRange: DateRangeLogic;
    spottedRange: DateRangeLogic;

    filters: {filter: Filter, lang: string}[];

    constructor(public filter: FilterService, public router: Router, public event: EventService, private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
        this.thisYear = new Date().getFullYear();

        this.uploadRange = new DateRangeLogic(
            formatter,
            calendar,
            NgbDate.from(filter.dateUploadedFrom),
            NgbDate.from(filter.dateUploadedTo)
        );

        this.spottedRange = new DateRangeLogic(
            formatter,
            calendar,
            NgbDate.from(filter.dateSpottedFrom),
            NgbDate.from(filter.dateSpottedTo)
        );

        this.filters = [
            {filter: filter.countries, lang: 'data_shorthand.countries'},
            {filter: filter.species, lang: 'data_shorthand.species'},
            {filter: filter.research_grade, lang: 'data_shorthand.research_grade'},
            {filter: filter.intertidal, lang: 'data_shorthand.intertidal'},
            {filter: filter.observe, lang: 'data_shorthand.observed'},
            {filter: filter.sediment, lang: 'data_shorthand.sediment'},
            {filter: filter.depth, lang: 'data_shorthand.depth'},
            {filter: filter.extensive, lang: 'data_shorthand.extent'},
            {filter: filter.algae, lang: 'data_shorthand.algae'},
            {filter: filter.flowers, lang: 'data_shorthand.flowers'},
            {filter: filter.shootLength, lang: 'data_shorthand.length'},
            {filter: filter.percentage_cover, lang: 'data_shorthand.percentage_cover'},
            {filter: filter.fishing, lang: 'data_shorthand.fishing'},
            {filter: filter.boats, lang: 'data_shorthand.boats'},
            {filter: filter.damages, lang: 'data_shorthand.damages'},
            {filter: filter.recreational_activity, lang: 'data_shorthand.recreational_activity'},
            //{filter: filter.changes, lang: 'data_shorthand.changes'},
            {filter: filter.additionalSpecies, lang: 'data_shorthand.additional_species'},
            {filter: filter.fishingGear, lang: 'data_shorthand.gear'},
            {filter: filter.fishingCaught, lang: 'data_shorthand.caught'},
            {filter: filter.flowering_density, lang: 'data_shorthand.flowering_density'},
            {filter: filter.fruiting_density, lang: 'data_shorthand.fruiting_density'},
            {filter: filter.number_of_seeds, lang: 'data_shorthand.number_of_seeds'},
            {filter: filter.seed_length, lang: 'data_shorthand.seed_length'},
            {filter: filter.water_temperature, lang: 'data_shorthand.water_temperature'},
            {filter: filter.water_temperature_measurement, lang: 'data_shorthand.water_temperature_measurement'},
        ]
    }

    /** Clears all the filters */
    clearFilters() {
        this.filter.reset();
    }

    /** Called when the report button is clicked */
    report() {
        this.event.showFilter.emit(false);
        this.router.navigateByUrl("/reports/sightings");
    }

    /** Updates the filter service with the dates and runs the filter */
    updateFilter() {
        this.filter.dateUploadedFrom = this.uploadRange.fromDate;
        this.filter.dateUploadedTo = this.uploadRange.toDate;
        this.filter.dateSpottedFrom = this.spottedRange.fromDate;
        this.filter.dateSpottedTo = this.spottedRange.toDate;
        this.filter.filter();
    }


}
